import { CommercialBenefits } from '@tenants';

export const benefitsConfig: CommercialBenefits = {
  joinUsLink: '/join-us',
  benefits: [
    {
      type: 'card',
      title: 'Global Coverage',
      description: 'Our unique real estate approach allows us to scale beyond borders, adding valuable resources to our community of industry experts.',
    },
    {
      type: 'video',
      url: '/ca-hero-1.mp4',
    },
    {
      type: 'card',
      title: 'Top League Advisor',
      description: 'Our advisors have access to extensive training and the latest tools and technology to enhance their skill sets and become formidable forces in the real estate industry.',
    },
    {
      type: 'card',
      title: 'Global Coverage',
      description: 'Our unique real estate approach allows us to scale beyond borders, adding valuable resources to our community of industry experts.',
    },
    {
      type: 'video',
      url: '/header-video2.mp4',
    },
    {
      type: 'card',
      title: 'Top League Advisor',
      description: 'Our advisors have access to extensive training and the latest tools and technology to enhance their skill sets and become formidable forces in the real estate industry.',
    },
    {
      type: 'card',
      title: 'Global Coverage',
      description: 'Our unique real estate approach allows us to scale beyond borders, adding valuable resources to our community of industry experts.',
    },
    {
      type: 'video',
      url: '/commercial-hero-test.mp4',
    },
    {
      type: 'card',
      title: 'Top League Advisor',
      description: 'Our advisors have access to extensive training and the latest tools and technology to enhance their skill sets and become formidable forces in the real estate industry.',
    },
  ] as const,
};
